/* TURN: curated cart add-ons (cart drawer + cart page): session-stable shuffle + quick add.
   Defensive by design: conservative syntax, every API guarded, every entry point wrapped in
   try/catch so nothing here can ever interrupt the theme's own product-form / cart-drawer scripts. */
(function () {
  'use strict';

  try {
    if (!window.customElements || typeof window.customElements.define !== 'function') return;
    if (window.customElements.get('turn-cart-upsell')) return;
  } catch (e) {
    return;
  }

  var ORDER_KEY = 'turn-cart-addons-order-v3';

  function rootUrl() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {
      /* ignore */
    }
    return '/';
  }

  function readOrder() {
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(ORDER_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function writeOrder(order) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(ORDER_KEY, JSON.stringify(order));
    } catch (e) {
      /* storage unavailable (private mode): keep the order for this render only */
    }
  }

  function getOrder(ids) {
    var order = readOrder();
    if (order) return order;
    order = ids.slice();
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = order[i];
      order[i] = order[j];
      order[j] = tmp;
    }
    writeOrder(order);
    return order;
  }

  function closestEl(node, selector) {
    while (node && node.nodeType !== 1) node = node.parentNode;
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  /* Copy the computed type of the theme's duties/taxes note onto the add-ons block (used on mobile). */
  function syncNoteStyle(el) {
    try {
      var scope = closestEl(el, 'cart-drawer') || document.getElementById('main-cart-footer') || document;
      var note = scope.querySelector('.tax-note:not(.turn-free-shipping):not(.turn-upsell__heading):not(.mto-note)');
      if (!note || !window.getComputedStyle) return;
      var cs = window.getComputedStyle(note);
      el.style.setProperty('--turn-note-size', cs.fontSize);
      el.style.setProperty('--turn-note-spacing', cs.letterSpacing);
      el.style.setProperty('--turn-note-line-height', cs.lineHeight);
    } catch (e) {
      /* fallbacks in CSS apply */
    }
  }

  function syncAll() {
    try {
      var blocks = document.querySelectorAll('turn-cart-upsell');
      for (var i = 0; i < blocks.length; i++) syncNoteStyle(blocks[i]);
    } catch (e) {
      /* ignore */
    }
  }

  try {
    if (typeof window.matchMedia === 'function') {
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      if (mobileQuery && typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', syncAll);
      } else if (mobileQuery && typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(syncAll);
      }
    }
  } catch (e) {
    /* ignore */
  }

  /* Kind of a row: 'culotte' (set in Liquid), 'brooch' (product URL contains "brooch"), else 'other'. */
  function kindOf(row) {
    var kind = row.getAttribute('data-kind') || '';
    if (kind === 'culotte') return kind;
    try {
      var link = row.querySelector('a[href]');
      var href = link ? (link.getAttribute('href') || '').toLowerCase() : '';
      if (href.indexOf('brooch') !== -1) return 'brooch';
    } catch (e) {
      /* ignore */
    }
    return 'other';
  }

  /* Rule: slot 1 = one culotte, slot 2 = one brooch (each session-random among those shown),
     then the bangles and other brooches (session-shuffled), then the remaining culottes as fillers. */
  function shuffleRows(el) {
    var tbody = el.querySelector('tbody');
    if (!tbody) return;
    var rows = Array.prototype.slice.call(tbody.querySelectorAll('.turn-upsell__item'));
    if (rows.length < 2) return;
    var ids = [];
    for (var i = 0; i < rows.length; i++) ids.push(rows[i].getAttribute('data-product-id'));
    var order = getOrder(ids);
    function rank(row) {
      var index = order.indexOf(row.getAttribute('data-product-id'));
      return index === -1 ? 9999 : index;
    }
    function byRank(a, b) {
      return rank(a) - rank(b);
    }
    var culottes = [];
    var brooches = [];
    var others = [];
    for (var r = 0; r < rows.length; r++) {
      var kind = kindOf(rows[r]);
      if (kind === 'culotte') {
        culottes.push(rows[r]);
      } else if (kind === 'brooch') {
        brooches.push(rows[r]);
      } else {
        others.push(rows[r]);
      }
    }
    culottes.sort(byRank);
    brooches.sort(byRank);
    var rest = others.concat(brooches.slice(1));
    rest.sort(byRank);
    var ordered = culottes.slice(0, 1).concat(brooches.slice(0, 1), rest, culottes.slice(1));
    for (var k = 0; k < ordered.length; k++) tbody.appendChild(ordered[k]);
  }

  /* Images must start loading immediately, whatever the row order (never lazy). */
  function eagerImages(el) {
    try {
      var imgs = el.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].getAttribute('loading') !== 'eager') imgs[i].setAttribute('loading', 'eager');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function showError(el, message) {
    try {
      var errorEl = el.querySelector('.turn-upsell__error');
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    } catch (e) {
      /* ignore */
    }
  }

  function addToBag(el, button) {
    var actions = closestEl(button, '.turn-upsell__actions');
    var select = actions ? actions.querySelector('select') : null;
    var variantId = Number(select ? select.value : button.getAttribute('data-variant-id'));
    if (!variantId || typeof window.fetch !== 'function') return;

    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    var useDrawer = !!(drawer && typeof drawer.renderContents === 'function' && !onCartPage);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    showError(el, '');

    var body = { id: variantId, quantity: 1 };
    if (useDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    function fail(message) {
      var fallback = window.cartStrings && window.cartStrings.error ? window.cartStrings.error : '';
      showError(el, message || fallback);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }

    window
      .fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          fail(result.data.description || result.data.message || '');
          return;
        }
        try {
          if (useDrawer && result.data.sections) {
            drawer.renderContents(result.data);
            return;
          }
        } catch (e) {
          /* fall through to a reload */
        }
        window.location.reload();
      })
      .catch(function () {
        fail('');
      });
  }

  class TurnCartUpsell extends HTMLElement {
    constructor() {
      super();
      var self = this;
      /* Keep size changes away from the cart's quantity listeners (cart-items / cart-drawer-items). */
      this.addEventListener('change', function (event) {
        event.stopPropagation();
      });
      this.addEventListener('click', function (event) {
        try {
          var button = closestEl(event.target, '.turn-upsell__add');
          if (!button || !self.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          addToBag(self, button);
        } catch (e) {
          /* never break the page */
        }
      });
    }

    connectedCallback() {
      try {
        syncNoteStyle(this);
        eagerImages(this);
        shuffleRows(this);
      } catch (e) {
        /* rows keep their server order */
      }
    }
  }

  try {
    if (!window.customElements.get('turn-cart-upsell')) {
      window.customElements.define('turn-cart-upsell', TurnCartUpsell);
    }
  } catch (e) {
    /* ignore */
  }
})();
